module.exports = __webpack_public_path__ + "img/260720945_4_10.62e6d64a.png";